import { Component, Input } from '@angular/core';
import { NgModel } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AccountResultDto } from 'src/app/dtos/account-result-dto.model';
import { InvoiceDetailsDto } from 'src/app/dtos/invoice-details-dto.model';
import { SendPaymentReceiptRequestDto } from 'src/app/dtos/send-payment-receipt-request-dto';
import { Dialog } from 'src/app/helpers/dialog';
import { AccountsReceivableService } from 'src/app/services/accounts-receivable.service';
import { ConfigService } from 'src/app/services/config.service';
import { ModeService } from 'src/app/services/mode.service';
import { OrderService } from 'src/app/services/order.service';

@Component({
  selector: 'app-send-payment-receipt-dialog',
  templateUrl: './send-payment-receipt-dialog.component.html',
  styleUrls: ['./send-payment-receipt-dialog.component.css']
})
export class SendPaymentReceiptDialogComponent {
private readonly _activatedRoute: ActivatedRoute | undefined;
  @Input() sendPaymentReceiptDialog = new Dialog<void>();
  getSelectedInvoicesSubscription: Subscription | undefined;
  isNotificationVisible = false;
  notificationVariant: any = '';
  orderIsReadySubscription: Subscription | undefined;
  emailNotificationMessage = '';
  accountInfo: AccountResultDto = new AccountResultDto();
  loggedInUserEmail:any;
  disableBillTo = false;
   selectedInvoicesList: InvoiceDetailsDto[] = [];
  disableOrderBy = false;
  disableShipTo = false;
  
  disableloggedInUser = false;
  disableSendEmail = false;
   emailIds: string[] = [];
  billToContactcheckbox: boolean = false;
  orderByContactcheckbox: boolean = false;
  shipToContactcheckbox: boolean = false;
  LoggedInUsercheckbox:boolean=false;
  loggedinName:any;
  CCrecipientsloggedInUserEmail = '';
  emailPattern = /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(;[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/;
  email = '';
  ccEmail='';
  EmailSubject = '';
  EmailBody = '';
  headerForTemplate = '';
  loggedInUserName = '';
  logged='';
  loading = false;
  visibleTextValue = '';
  selectedInvoices: InvoiceDetailsDto[] = [];
  invoiceIds: number[] = [];

  constructor(
    public accountsReceivableService: AccountsReceivableService,
    public modeService: ModeService,
    public orderService: OrderService,
    activatedRoute: ActivatedRoute,
    public readonly configService: ConfigService,
  ){
     this._activatedRoute = activatedRoute;
  }

  ngOnInit(){
    this.headerForTemplate = 'Payment Receipt Email';
    const loggedInUserEmail = this.configService.getLoggedInUserEmail();
    this.loggedInUserEmail = loggedInUserEmail;
    this.CCrecipientsloggedInUserEmail = loggedInUserEmail;
    this.EmailSubject = "Account ID "+this.orderService.receiptAccountId+"-"+"Payment Receipt(s) Attached";
    const loggedInUserName = this.configService.getLoggedInUserName();
    this.EmailBody = 'Attached is the payment receipt copy that you requested.' + '<br><br>' + "Regards," + '<br>' + loggedInUserName + "<br>" + this.loggedInUserEmail;
    this.loggedinName= loggedInUserName;
    this.getSelectedInvoicesSubscription = this.accountsReceivableService.getSelectedInvoicesEmitter.
      subscribe((invoices: InvoiceDetailsDto[]) => {
        this.selectedInvoicesList = invoices;
      });
    this.clickSendSelectedToPDF();    
  }

  cancelDialog() {
    this.sendPaymentReceiptDialog.close();
  }

sendPdf(toEmailModel: NgModel, ccEmailModel: NgModel) {
 
  //  STOP if TO email is invalid
  if (toEmailModel.invalid) {
    toEmailModel.control.markAsTouched();
    this.displayNotification(true, "Please enter a valid email address", false);
    return;
  }

  //  STOP if CC email is invalid
  if (ccEmailModel.invalid) {
    ccEmailModel.control.markAsTouched();
    this.displayNotification(true, "Please enter a valid email address", false);
    return;
  }

  // --- Your existing logic starts here ---
  const payload = new SendPaymentReceiptRequestDto();
  payload.InvoiceIds = [];
  payload.EmailRecipients = this.email;
  payload.EmailBody = (this.EmailBody ?? '').trim();
  payload.AccountId = this.orderService.receiptAccountId;
  payload.Subject = "Account ID " + this.orderService.receiptAccountId + " - Payment Receipt(s) Attached";
  payload.LoggedInUserEmail = this.loggedInUserEmail;

  this.selectedInvoicesList.forEach(item => {
    const id = Number(item.invoiceNumber);
    if (!Number.isNaN(id)) {
      payload.InvoiceIds.push(id);
    }
  });

  this.loading = true;
  const waitListMessage = 'Sending PDF';
  this.visibleTextValue = 'Sending Email';
  this.modeService.addToWaitList(waitListMessage);

  this.orderService.emailReceiptInvoicePdfs(payload)
    .subscribe({
      next: (res) => {
        this.modeService.removeFromWaitList(waitListMessage);
        this.displayNotification(true, 'Mail sent successfully', true);
        this.selectedInvoicesList = [];

        setTimeout(() => {
          this.displayNotification(false, '');
          this.cancelDialog();
        }, 2000);
      },
      error: (err) => {
        this.modeService.removeFromWaitList(waitListMessage);
        this.displayNotification(true, 'An error occurred while sending an email', false);
      }
    });
}


  displayNotification(isNotificationVisible: boolean, emailNotificationMessage: string, isSuccess: boolean = false) {
    this.isNotificationVisible = isNotificationVisible;
    this.emailNotificationMessage = emailNotificationMessage;

    if (typeof isSuccess !== 'undefined') {
      this.notificationVariant = isSuccess ? 'success' : 'error';
    }
  }
  
 changeEmail() {
    let emailIds: string[] = [];
    this.email = '';
    emailIds.push(this.billToContactcheckbox === true ? this.orderService.orderDto.billToDto.email || '' : '');
    emailIds.push(this.orderByContactcheckbox === true ? this.orderService.orderDto.orderByDto.email || '' : '');
    emailIds.push(this.shipToContactcheckbox === true ? this.orderService.orderDto.shipToDto.email || '' : '');
    emailIds.push(this.LoggedInUsercheckbox==true? this.loggedInUserEmail||'':'');
    emailIds = [...new Set(emailIds)];
    this.email = emailIds.filter(e => e).join(';');
    this.validateEmailAddress();
  }


downloadInvoicePdf() {
  this.selectedInvoicesList.forEach(item => {
    const invoiceId = Number(item.invoiceNumber);

    this.orderService.DownloadInvoicePdf(invoiceId)
      .subscribe({
        next: (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Invoice_${invoiceId}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        error: (err) => {   // ✅ ERROR HANDLING ADDED
          console.error('Download error:', err);
          alert('Unable to download payment receipt');
        }
      });
  });
}


  validateEmailAddress(){
    if ( this.email === '' && this.CCrecipientsloggedInUserEmail === '') {
      this.disableSendEmail = true;   
      return;
    }

    let emailList = this.email?.split(";");
     emailList = emailList.concat(this.CCrecipientsloggedInUserEmail?.split(";"))?.map(e => e.trim()); 
    if(emailList.every(element => !new RegExp(this.emailPattern).test(element))){
      this.disableSendEmail = true;
    }
    else{
      this.disableSendEmail = false;
    }
  }

  onEmailBodyChange(event: any){
    this.EmailBody = event.target.innerHTML;
  }

  clickSendSelectedToPDF() {
     if(this.accountsReceivableService.selectedOrder > 0){
       this.orderService.getOrderInformation(this.accountsReceivableService.selectedOrder);
     }
    this.orderIsReadySubscription = this.orderService.orderIsReady.subscribe(() => {
      this.email = '';
      this.accountsReceivableService.getSelectedInvoicesEmitter.
        subscribe((invoices: InvoiceDetailsDto[]) => {
          const distinctOrderByIds = [...new Set(invoices.map(item => item.orderByContactId))];
          const distinctShipToIds = [...new Set(invoices.map(item => item.shipToContactId))];
       

          if (this.orderService.orderDto.billToDto.email !== null && this.orderService.orderDto.billToDto.email !== '') {
            this.billToContactcheckbox = true;
            this.email = this.orderService.orderDto.billToDto.email;
            this.disableBillTo = false;
          }
          else {
            this.disableBillTo = true;
          }
          this.disableOrderBy = distinctOrderByIds.length > 1 || !this.orderService.orderDto.orderByDto.email;

          this.disableShipTo = distinctShipToIds.length > 1 || !this.orderService.orderDto.shipToDto.email;
        });
    });
  }
}
